import React from 'react';
import Builder from '../../Components/builderContent';
import AbilitiesModal from '../../Components/modal/abilitiesModal';
import PokemonInfo from '../../Components/pokemonInfo';
import BuilderHeader from '../template/header/builderHeader';
import { BuildProvider } from '../../Data/Context/buildData';
import TeamMatesModal from '../../Components/modal/teamMateModal';
import PersonalitiesModal from '../../Components/modal/personalitiesModal';//Ponto 14 importar o novo modal
import HeldItemsModal from '../../Components/modal/heldItemsModal';
import HiddenSkillsModal from '../../Components/modal/hiddenSkillsModal';
import SaveAndShare from '../../Components/modal/saveAndShare';
import GearsModal from '../../Components/modal/gearsModal';
import DeleteBuildModal from '../../Components/modal/deleteBuildModal';
import LoginModal from '../../Components/modal/loginModal';

const BuilderPage = ({ classes }) => {
    return (
        <BuildProvider>
            <div className={classes}>
                <BuilderHeader />
                <PokemonInfo />
                <Builder />
            </div>
            <TeamMatesModal />
            <AbilitiesModal />
            <PersonalitiesModal />{/* Ponto 15 chamar o modal */}
            <HeldItemsModal />
            <GearsModal />
            <HiddenSkillsModal />
            <SaveAndShare />
            <DeleteBuildModal />
            <LoginModal />
        </BuildProvider>
    )
}
export default BuilderPage;